<template>
    <b-badge v-if="value === TranscriptionStatus.Pending" variant="secondary" class="m-0">
        Queued
    </b-badge>
    <b-badge v-else-if="value === TranscriptionStatus.Downloading" variant="info" class="m-0">
        Downloading
    </b-badge>
    <b-badge v-else-if="value === TranscriptionStatus.Transcribing" variant="primary" class="m-0">
        Transcribing
    </b-badge>
    <b-badge v-else-if="value === TranscriptionStatus.Completed" variant="success" class="m-0">
        Complete
    </b-badge>
    <b-badge v-else-if="value === TranscriptionStatus.Failed" variant="danger" class="m-0">
        Failed
    </b-badge>
</template>

<script>
const TranscriptionStatus = Object.freeze({
    Pending: 0,
    Downloading: 1,
    Transcribing: 2,
    Completed: 3,
    Failed: 4,
});

export default {
    name: "TranscriptionStatusBadge",
    props: {
        value: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            TranscriptionStatus,
        };
    },
};
</script>
